/**
 * 强类型限制, 增加属性必须加上类型限制以及readonly
 * 如果没有显式定义类型, 则其他文件引用后无法提示语法
 */
type APIS = {
	readonly AUTH_SIGNIN: string;
	
	readonly CHANGE_PWD: string;
	readonly RESET_PWD: string;
	readonly AUTH_RETRIEVE: string;

	readonly ACCOUNT_CURRENT: string;
	readonly ACCOUNT_CREATE: string;
	readonly ACCOUNT_UPDATE: string;
	readonly ACCOUNT_LIST: string;
	readonly ACCOUNT_LOAD: string;
	readonly ACCOUNT_SECURE_INFO_LOAD: string;
	readonly ACCOUNT_UPLOAD_SYNC: string;
	readonly ACCOUNT_MENU_BY_TENANT_LOAD: string;
	readonly ACCOUNT_MENU_BY_TENANT_UPDATE: string;
    readonly ACCOUNT_CHECK_SALES_AUTH: string;
    readonly ACCOUNT_INFO: string;

	readonly VERIFICATION_GENERATE_IMAGE: string;
	readonly VERIFICATION_SEND_MAIL: string;
	readonly VERIFICATION_CODE: string;

	readonly STS_ASK_TOKEN: string;
	readonly STS_ASK_URL: string;

	readonly HOME_PRODUCTS: string;
	readonly GET_MESSAGE_LIST: string;
	
	readonly CREATE_POLICY: string;
	readonly UPDATE_POLICY: string;
	readonly CALCULATE_PREMIUM: string;
	readonly SUBMIT_POLICY: string;
	readonly UNDERWRITE: string;
	readonly APPLY: string;
	readonly ISSUE: string;

	readonly REGISTER_VERIFICATION_SEND_MAIL: string;
	readonly REGISTER_VERIFICATION_CODE: string;

	readonly QUERY_QUOTE: string;
	readonly QUERY_POLICY: string;
	readonly QUERY_ENDO: string;

	readonly QUERY_ENDO_APPLY: string;
	readonly ENDO_APPLY: string;
	readonly ENDO_INFO: string;

	readonly CANCLE_QUOTE: string;

	readonly FIND_QUOTATION_DETAILS: string;
	readonly FIND_POLICY_DETAILS: string;

	readonly UPLOAD_EXCEL: string;
	readonly DOWNLOAD_EXCEL: string;
};

/**
 * 所有API路由声明
 */
export default {
	AUTH_SIGNIN: '/rest/v1/auth/signin4Enterprise',
	CHANGE_PWD: '/rest/v1/auth/changep',
	RESET_PWD: '/rest/v1/auth/restp',
	AUTH_RETRIEVE: '/rest/v1/auth/retrieve',

	ACCOUNT_CREATE: '/rest/v1/auth/register4Enterprise',
	ACCOUNT_UPDATE: '/rest/v1/auth/update4Enterprise',
	ACCOUNT_LOAD: '/rest/v1/auth/getAccountInfo',
	ACCOUNT_SECURE_INFO_LOAD: '/rest/v1/account/secure/',
	ACCOUNT_UPLOAD_SYNC: '/rest/v1/account/uploadSync',
	ACCOUNT_MENU_BY_TENANT_LOAD: '/rest/v1/account/menus/tenant/load/',
	ACCOUNT_MENU_BY_TENANT_UPDATE: '/rest/v1/account/menus/tenant/update',
	ACCOUNT_CHECK_SALES_AUTH: '/rest/v1/account/checkAgentSaleAuthority/',
    ACCOUNT_INFO: '/rest/v1/auth/getAccountInfo',
	// 验证-生成验证码图片
	VERIFICATION_GENERATE_IMAGE: '/rest/v1/verification/generateImage/:userName',
	// 验证-发送验证码邮件
	VERIFICATION_SEND_MAIL: '/rest/v1/verification/sendMail/:verificationType/:userName',
	// 验证-校验验证码
	VERIFICATION_CODE: '/rest/v1/verification/verify/:verificationType/:verificationCode/:userName',
	// 获取访问OSS的STS Token
	STS_ASK_TOKEN: '/rest/v1/sts/ask/token',
	STS_ASK_URL: '/rest/v1/sts/ask/access_url?filePath=:url',
	// 注册验证-发送验证码邮件
	REGISTER_VERIFICATION_SEND_MAIL: '/rest/v1/verification/sendMailRegister/2/:email',
	// 注册验证-校验验证码
	REGISTER_VERIFICATION_CODE: '/rest/v1/verification/sendMail/:verificationType/:userName',
    // 获取产品列表 90021代表三井
	HOME_PRODUCTS: '/rest/v1/commercial_product/list/tenant/90021',
	// 首页获取消息列表
	GET_MESSAGE_LIST: '/rest/v1/policyMessage/my/loadList',
	// 算费
	CALCULATE_PREMIUM: '/rest/v2/policy/calculate',
	// 提交投保
	SUBMIT_POLICY: '/rest/v2/policy/submitPolicy',
	// 核爆
	UNDERWRITE: '/rest/v2/policy/underwrite',
	// 投保
	APPLY: '/rest/v2/policy/apply',
	// 出单
	ISSUE: '/rest/v2/policy/issue',
	// 新建单
	CREATE_POLICY: '/rest/v2/policy/create',
	// 保存单
	UPDATE_POLICY: '/rest/v2/policy/update',

	QUERY_QUOTE: '/rest/v1/policy/list/my/desk/criteria',
	QUERY_POLICY: '/rest/v1/policy/list/my/desk/criteria',
	QUERY_ENDO: '/rest/v1/policy/list/my/desk/criteria',

	QUERY_ENDO_APPLY: '/rest/v1/policyEndorsement/my/list/criteria',
	ENDO_APPLY: '/rest/v1/policyEndorsement/my/create',
	ENDO_INFO: '/rest/v1/policyEndorsement/my/getInfoByEndoNo/:endoNo',
	FIND_QUOTATION_DETAILS: '/rest/v2/policy/find/quoteNo/:quotationNo',
	FIND_POLICY_DETAILS: '/rest/v2/policy/find/policyNo/:policyNo',

	CANCLE_QUOTE: '/rest/v2/policy/withdraw',
	
	UPLOAD_EXCEL: '/rest/v2/policy/auxiliary/excel/2json',
	DOWNLOAD_EXCEL: '/rest/v2/policy/auxiliary/json/2excel'
} as APIS;
